
const WhatWeLookForSection = () => {
  const criteria = [
    {
      icon: 'ri-map-pin-line',
      title: 'Location',
      description: 'U.S.-based businesses in strong local communities'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Owner Earnings',
      description: 'Typically $150k-$2M in annual owner earnings'
    },
    {
      icon: 'ri-store-line',
      title: 'Business Type',
      description: 'Service, trade, and owner-operated businesses'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance',
      description: 'Profitable and well-established'
    }
  ];

  return (
    <section id="what-we-look-for" className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            What We're Looking For
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We focus on acquiring established, profitable businesses that serve their communities well and have strong foundations for continued growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {criteria.map((item, index) => (
            <div key={index} className="bg-soft-gray rounded-lg p-6 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-full mx-auto mb-4">
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <h3 className="font-semibold text-navy mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-navy rounded-lg p-8 text-center">
          <h3 className="font-playfair text-2xl font-semibold text-white mb-4">
            Examples of Businesses We Acquire
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-300">
            <div>HVAC Companies</div>
            <div>Plumbing Services</div>
            <div>Auto Repair Shops</div>
            <div>Landscaping Firms</div>
            <div>Electrical Contractors</div>
            <div>Cleaning Services</div>
            <div>Restaurants</div>
            <div>Laundromats</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeLookForSection;
